import api from '@/components/mixins/baseApi';

export default {
  mixins: [api],

  methods: {
    // scope — раздел каталога: 'exhibitor', 'participant' и т.д.
    getFilters(scope) {
      this.$store.commit('setProgressVal', 1);
      return this.baseAxios({
        method: 'get',
        url: `${this.$store.getters.apiBasePath}/${scope}/filter/config`,
        onDownloadProgress: (progressEvent) => {
          this.$store.commit('setProgressVal', Math.round(progressEvent.progress * 100));
        },
      })
        .then((data) => {
          this.$store.commit('setProgressVal', 100);
          return data?.results || [];
        })
        .catch((error) => {
          this.$store.commit('setProgressVal', 100);
          return Promise.reject(error);
        });
    },
  },
};
